import { render } from "./CommandeDetailsPage.vue?vue&type=template&id=e381f5d2&scoped=true"
import script from "./CommandeDetailsPage.vue?vue&type=script&lang=js"
export * from "./CommandeDetailsPage.vue?vue&type=script&lang=js"

import "./CommandeDetailsPage.vue?vue&type=style&index=0&id=e381f5d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e381f5d2"]])

export default __exports__